import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "64",
      height: "20",
      rx: "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m47.941 9.819-1.983-2.246h-1.16v5.2h1.211V9.454l1.81 1.965h.224l1.78-1.965v3.317h1.21V7.573h-1.159L47.941 9.82ZM56.802 7.573l-3 3.38v-3.38H52.59v5.2h1.11l3-3.38v3.38h1.21v-5.2h-1.108ZM38.278 9.476c0 .827.444 1.48 1.127 1.753l-1.28 1.543h1.482l1.164-1.404h1.26v1.404h1.21V7.573h-3.082c-1.15 0-1.881.8-1.881 1.903Zm3.753-.758v1.538h-1.648c-.55 0-.844-.312-.844-.77 0-.457.305-.77.844-.77l1.648.002ZM32.652 8.613c-.074 1.788-.445 2.942-1.17 2.942h-.181v1.248l.193.01c1.454.083 2.258-1.216 2.39-4.055h1.913v4.014h1.208V7.573h-4.312l-.041 1.04ZM28.095 7.5c-1.638 0-2.816 1.155-2.816 2.672 0 1.57 1.282 2.684 2.816 2.684 1.597 0 2.838-1.176 2.838-2.684 0-1.507-1.241-2.672-2.838-2.672Zm0 4.107c-.926 0-1.556-.613-1.556-1.435 0-.842.63-1.439 1.555-1.439.925 0 1.577.624 1.577 1.44 0 .814-.66 1.434-1.576 1.434ZM23.995 7.583h-4.273l-.04 1.04c-.061 1.498-.445 2.922-1.17 2.943l-.336.01V14h1.221v-1.227h4.242V14h1.23v-2.434h-.874V7.583Zm-1.21 3.983H20.2c.437-.676.671-1.653.712-2.797h1.871v2.797ZM15.391 6.4h-1.174v6.4h1.174V6.4ZM12.652 6.8h-1.174v6.4h1.174V6.8ZM9.913 7.2H8.74v6.4h1.174V7.2ZM7.174 7.6H6V14h1.174V7.6Z"
    }, null, -1)
  ])))
}
export default { render: render }